/**
 * Initials for the account avatar, in place of a photo.
 *
 * Usernames in this pool are inconsistent - some are email addresses, some are
 * `first.last`, some a single token - so this narrows to the part that
 * identifies the person before picking letters: the local part of an email,
 * split on the usual separators.
 */
export function initialsFrom(value: string): string {
  const local = value.split('@')[0] ?? value;
  const parts = local.split(/[.\-_\s]+/).filter(Boolean);

  if (parts.length >= 2) {
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
  }
  return (parts[0] ?? value).slice(0, 2).toUpperCase();
}
